(function () {
  const variants = window.PDP_VARIANTS || [];

  function getSelectedVariantId() {
    const form = document.querySelector('form[action*="/cart/add"]');
    const idInput = form && form.querySelector('[name="id"]');
    const id = idInput ? parseInt(idInput.value, 10) : null;
    return Number.isFinite(id) ? id : null;
  }

  function getSelectedSku() {
    const id = getSelectedVariantId();
    const v = id ? variants.find(x => Number(x.id) === Number(id)) : null;
    return v && v.sku ? String(v.sku).trim() : '';
  }

  /**
   * Safely filter + sort a gallery by SKU.
   * If fewer than 2 matching images are found,
   * the function does NOTHING and preserves default behaviour.
   */
  function safeFilterAndSort(nodes, sku) {
    if (!nodes.length || !sku) return;

    const matching = [];
    const nonMatching = [];

    nodes.forEach(el => {
      const itemSku = (el.getAttribute('data-sku') || '').trim();
      if (itemSku === sku) matching.push(el);
      else nonMatching.push(el);
    });

    // 🛑 SAFETY GUARD
    // Not enough compliant images → do nothing
    if (matching.length < 2) {
      nodes.forEach(el => (el.style.display = ''));
      return;
    }

    // Hide non-matching images
    nonMatching.forEach(el => (el.style.display = 'none'));

    // Sort matching images by data-order
    matching.sort((a, b) => {
      const ao = parseInt(a.getAttribute('data-order') || '999', 10);
      const bo = parseInt(b.getAttribute('data-order') || '999', 10);
      return ao - bo;
    });

    // Re-append in sorted order
    const parent = matching[0].parentElement;
    matching.forEach(el => {
      el.style.display = '';
      parent.appendChild(el);
    });
  }

  function apply() {
    const sku = getSelectedSku();
    if (!sku) return;

    // Desktop gallery
    const desktop = document.querySelector('[data-pdp-gallery-desktop]');
    if (desktop) {
      const items = Array.from(
        desktop.querySelectorAll('[data-pdp-media-item]')
      );
      safeFilterAndSort(items, sku);
    }

    // Mobile gallery
    const mobile = document.querySelector('.s-main-product__gallery--mobile');
    if (mobile) {
      const slides = Array.from(
        mobile.querySelectorAll('[data-pdp-slide]')
      );
      safeFilterAndSort(slides, sku);

      // Refresh Swiper after DOM reordering
      const swiperEl = mobile.querySelector('swiper-container');
      if (swiperEl && typeof swiperEl.update === 'function') {
        swiperEl.update();
      }
    }
  }

  // Initial run
  document.addEventListener('DOMContentLoaded', apply);

  // Variant change (most themes)
  document.addEventListener('change', apply);

  // Fallback polling for themes without reliable events
  let lastVariantId = null;
  setInterval(() => {
    const id = getSelectedVariantId();
    if (id && id !== lastVariantId) {
      lastVariantId = id;
      apply();
    }
  }, 400);
})();
